module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.2ec256c.woff2";